import React from "react"
import HeaderSectionLeft from "./HeaderSectionLeft.jsx"
import HeaderSectionRight from "./HeaderSectionRight.jsx"
import TopRightPageBg from "../TopRightPageBg"

const HeaderSection = () => {
  return (
    <div className="relative bg-gradient_header lg:pt-6 overflow-hidden">
      <div
        className="flex w-full flex-col lg:flex-row lg:max-w-w2_l xl:max-w-w2_xl lg:h-[534px] xl:h-[628px] items-center justify-center gap-12 lg:gap-0 px-4 md:px-px1_l lg:px-px1_xl xl:px-[72px] pt-[40px] pb-4 md:py-[56px] mx-auto"
      >
        <HeaderSectionLeft />
        <HeaderSectionRight />
      </div>

      <TopRightPageBg />
    </div>
  );
};

export default HeaderSection;
